(() => {

  if (window.WorkWheelConfigurator) {

    window.WorkWheelConfigurator.init();

    return;

  }

  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

  const sort = values => [...new Set(values)].sort(collator.compare);

  const norm = value => String(value ?? '').trim().replace(/\.0+$/, '');

  const etText = value => Number(value) > 0 ? '+' + Number(value) : String(Number(value));

  const read = id => {

    const encoded = JSON.parse(document.getElementById(id)?.textContent || 'null');

    return typeof encoded === 'string' ? JSON.parse(encoded) : encoded;

  };

  function setup(root) {

    if (root.workController) return;

    const sectionId = root.dataset.workSection;

    const section = document.getElementById('MainProduct-' + sectionId);

    const form = root.closest('form');

    if (!section || !form) return;

    if (section.workController) section.workController.abort();

    const controller = new AbortController();

    root.workController = controller;

    section.workController = controller;

    const on = (element, event, handler, capture = false) => element.addEventListener(event, handler, { capture, signal: controller.signal });

    let config, labels;

    try { config = read('work-config-data-' + sectionId); labels = read('work-config-labels-' + sectionId); } catch { config = null; }

    if (config?.version !== 1 || !config.sizes) config = null;

    labels ||= {};

    const picker = section.querySelector('variant-radios,variant-selects');

    let variants = [];

    try { variants = JSON.parse(section.querySelector('[data-wheel-variants]')?.textContent || '[]'); } catch { variants = []; }

    const fields = {};

    for (const [key, name] of Object.entries({rim:'Rim type',pcd:'PCD',face:'Disk face',offset:'Offset',color:'Color',notes:'Custom request'})) fields[key] = root.querySelector('[name="properties[' + name + ']"]');

    const warning = root.querySelector('[role="alert"]');

    const lipBox = root.querySelector('[data-lip-box]');

    const lipValue = root.querySelector('[data-lip-value]');

    const lipProperty = root.querySelector('[data-lip-property]');

    const help = root.querySelector('[data-help]');

    const row = key => root.querySelector('[data-field="' + key + '"]');

    const native = name => picker ? [...picker.querySelectorAll('input[type="radio"],select')].filter(input => input.name.replace(/^options\[/,'').replace(/\]$/,'').toLowerCase() === name.toLowerCase()) : [];

    const option = name => norm(native(name).find(input => input.tagName === 'SELECT' || input.checked)?.value);

    const key = () => option('Diameter') + 'x' + option('Width');

    const size = () => config?.sizes?.[key()];

    const rims = () => size()?.rim_types || {};

    const pcds = () => rims()[fields.rim.value]?.pcds || {};

    const faces = () => pcds()[fields.pcd.value]?.faces || {};

    function offsets() {

      const entry = faces()[fields.face.value];

      let points = [];

      if (Array.isArray(entry)) points = entry.map(item => Array.isArray(item) ? { et:item[0], lip_mm:item[1] } : item);

      else if (entry && typeof entry === 'object') {

        const max = Number(entry.et_max), min = Number(entry.et_min), first = Number(entry.lip_at_et_max_mm), last = Number(entry.lip_at_et_min_mm);

        if ([max,min,first,last].every(Number.isInteger) && max >= min && max - min <= 250 && last - first === max - min) points = Array.from({length:max-min+1}, (_,i) => ({et:max-i,lip_mm:first+i}));

      }

      return points.filter(point => point && point.et !== '' && point.et !== null && Number.isFinite(Number(point.et))).map(point => ({...point,et:etText(point.et)})).sort((a,b) => Number(a.et)-Number(b.et));

    }

    function setOptions(input, values, placeholder) {

      const previous = input.value;

      input.replaceChildren(new Option(placeholder || '', ''));

      for (const value of values) input.add(new Option(value, value));

      if (values.includes(previous)) input.value = previous;

      else if (values.length === 1) input.value = values[0];

    }

    function setField(name, values) {

      setOptions(fields[name], values, labels['select_' + name]);

      row(name).hidden = values.length === 1;

      fields[name].disabled = !size() || !values.length;

    }

    function updateLip() {

      const point = offsets().find(point => point.et === fields.offset.value);

      const valid = point?.lip_mm !== null && point?.lip_mm !== undefined && point?.lip_mm !== '' && Number.isFinite(Number(point?.lip_mm));

      const value = valid ? Number(point.lip_mm) + ' mm' : '';

      lipBox.hidden = !valid;

      lipValue.textContent = value;

      lipProperty.value = value;

      lipProperty.disabled = !valid;

    }

    function updateNotes() {

      const custom = fields.color.value === labels.custom;

      fields.notes.required = custom;

      fields.notes.placeholder = custom ? labels.describe : labels.optional;

      help.hidden = !custom;

      fields.notes.setCustomValidity('');

    }

    function updateOffsets() { setField('offset', offsets().map(point => point.et)); updateLip(); }

    function updateFaces() { setField('face', sort(Object.keys(faces()).filter(face => {

      const data = faces()[face]; return Array.isArray(data) ? data.length : !!data;

    }))); updateOffsets(); }

    function updatePcd() { setField('pcd', sort(Object.keys(pcds()))); updateFaces(); }

    function updateRim() { setField('rim', sort(Object.keys(rims()))); updatePcd(); }

    function updateColors() {

      const available = size()?.colors || config?.colors || [];

      const colors = sort(available.map(String));

      if (config?.custom_color || size()?.custom_color) colors.push(labels.custom);

      setField('color', colors);

      updateNotes();

    }

    function sortNativeControls() {

      if (!picker) return;

      for (const fieldset of picker.querySelectorAll('fieldset')) {

        const container = fieldset.querySelector('.product-form__container');

        if (container) [...container.children].sort((a,b) => Number(a.querySelector('input')?.value)-Number(b.querySelector('input')?.value)).forEach(item => container.append(item));

      }

      for (const select of picker.querySelectorAll('select')) [...select.options].sort((a,b) => Number(a.value)-Number(b.value)).forEach(item => select.append(item));

    }

    const sizeOptions = window.WheelSizeOptions.create(picker, variants, variant => variant.available !== false && !!config?.sizes?.[norm(variant.options[0]) + 'x' + norm(variant.options[1])]);

    function ensureValidWidth() { sizeOptions.refresh(); }

    let currentKey = '';

    function updateSize(force = false) {

      const selectedKey = key();

      if (!force && selectedKey === currentKey) return;

      currentKey = selectedKey;

      const valid = !!size();

      warning.hidden = valid;

      warning.textContent = labels.unavailable;

      root.dataset.workState = valid ? 'ready' : 'unavailable';

      if (valid) updateRim();

      else {

        for (const name of ['rim','pcd','face','offset']) { setField(name, []); row(name).hidden = false; }

        lipBox.hidden = true; lipProperty.disabled = true; lipProperty.value = '';

      }

      updateColors();

    }

    function validate(event) {

      ensureValidWidth(); updateSize(); updateLip();

      const variant = variants.find(variant => norm(variant.options[0]) === option('Diameter') && norm(variant.options[1]) === option('Width'));

      const variantInput = form.querySelector('[name="id"]');

      const point = offsets().find(point => point.et === fields.offset.value);

      const colorValid = [...fields.color.options].some(item => item.value && item.value === fields.color.value);

      const valid = !!config && !!size() && variant && variant.available !== false && String(variant.id) === variantInput?.value && !!rims()[fields.rim.value] && !!pcds()[fields.pcd.value] && !!faces()[fields.face.value] && !!point && colorValid;

      fields.notes.setCustomValidity(fields.notes.required && !fields.notes.value.trim() ? labels.required : '');

      const bad = Object.values(fields).find(input => !input.disabled && !input.checkValidity());

      if (!valid || bad) {

        event.preventDefault(); event.stopImmediatePropagation();

        warning.textContent = labels.invalid; warning.hidden = false;

        if (bad) { row(Object.keys(fields).find(name => fields[name] === bad))?.removeAttribute('hidden'); bad.reportValidity(); }

        else warning.scrollIntoView({block:'nearest'});

        return false;

      }

      warning.hidden = true;

      return true;

    }

    sortNativeControls(); ensureValidWidth(); updateSize(true);

    const selected = variants.find(variant => norm(variant.options[0]) === option('Diameter') && norm(variant.options[1]) === option('Width'));

    if (selected && form.querySelector('[name="id"]')?.value !== String(selected.id)) picker?.onVariantChange?.();

    on(section,'change',event => {

      if (picker?.contains(event.target) && event.target.matches('input[type="radio"],select')) ensureValidWidth();

    }, true);

    on(section,'change',event => {

      if (picker?.contains(event.target) && event.target.matches('input[type="radio"],select')) updateSize();

    });

    on(root,'change',event => {

      if (event.target === fields.rim) updatePcd();

      else if (event.target === fields.pcd) updateFaces();

      else if (event.target === fields.face) updateOffsets();

      else if (event.target === fields.offset) updateLip();

      else if (event.target === fields.color) updateNotes();

      warning.hidden = !!size();

    });

    on(fields.notes,'input',()=>fields.notes.setCustomValidity(''));

    on(form,'submit',validate,true);

    on(form,'click',event => {

      const button = event.target.closest('button[type="submit"],input[type="submit"]');

      if (button) validate(event);

    },true);

    const fontSource = section.querySelector('#variants-container .variants-label .h5');

    if (fontSource) {

      const styles = getComputedStyle(fontSource);

      root.style.fontFamily = styles.fontFamily;

      root.querySelectorAll('.work-wheel-config__label').forEach(label => {label.style.fontFamily=styles.fontFamily;label.style.fontSize=styles.fontSize;});

    }

  }

  const init = () => document.querySelectorAll('.work-wheel-config[data-work-section]').forEach(setup);

  window.WorkWheelConfigurator = { init };

  init();

  document.addEventListener('DOMContentLoaded',init);

  document.addEventListener('shopify:section:load',init);

  const observer = new MutationObserver(records => {

    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('.work-wheel-config') || node.querySelector('.work-wheel-config'))))) init();

  });

  observer.observe(document.documentElement,{childList:true,subtree:true});

})();



